export default {
  symbolsKeyValue: '#+-',
  layout: [
    ['!', '@', '#', '$', '%', '&'],
    ['~', '*', '¿', '/', '?', '^'],
    ['_', '`', ';', ':', '|', '='],
    ['ç', '-', '[', ']', '{', '}'],
    ['¡', 'ü', '.', ',', '+', 'º'],
    ['<', '>', '(', ')', '\'', '"'],
    ['á', 'é', 'í', 'ó', 'ú', 'ñ']
  ]
}



// WEBPACK FOOTER //
// ./src/components/Keyboard/layouts/tvSymbols.js